import React, { Component } from "react";
import Amplify, { Auth, Storage } from "aws-amplify";
import { I18n } from "@aws-amplify/core";
import {
  Authenticator,
  Greetings,
  ConfirmSignIn,
  ConfirmSignUp,
  ForgotPassword,
  RequireNewPassword,
  SignIn,
  SignUp,
  VerifyContact,
  withAuthenticator
} from "aws-amplify-react";
import "./App.css";

import TopPanel from "./TopPanel";
import Utils from "./Utils";
import ViewProjects from "./UserProject/NiceViewProjects";

import { AWS_CONFIG } from "./constants";

import {
  FormField,
  Input,
  InputLabel,
  Hint,
  Link,
  SectionFooter,
  SectionFooterPrimaryContent,
  Button,
  SectionFooterSecondaryContent,
  Nav,
  FormSection,
  NavItem,
  SelectInput,
  NavBar,
  NavRight,
  SectionHeader,
  SectionBody
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import MyTheme from "./AmplifyTheme";
import { Icon } from "@material-ui/core";

import AppContext from "./AppContext";

Amplify.configure(AWS_CONFIG);

const MyThemeTweak = {
  navBar:{border:"none",minHeight:"120px",marginTop:"10px"},
  nav: { backgroundColor: "white", color: "black",border:"none" },
  signInButton: {
    backgroundColor: "white",
    color: "black",
    border: "1px solid"
  },
  button: {
    backgroundColor: "white",
    color: "black",
    border: "1px solid"
  },
  navButton: {
    minWidth: "90px",
    display: "inline-block",
    marginBottom: "0",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "1.42857143",
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    touchAction: "manipulation",
    cursor: "pointer",
    userSelect: "none",
    backgroundImage: "none",
    color: "black",
    backgroundColor: "inherit",
    borderColor: "#ccc",
    textTransform: "uppercase",
    padding: "10px 0",
    letterSpacing: "1.1px",
    border:"1px solid black"
  },
  toast: {
    height: "90px"
  }
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { viewVersion: 1 };
  }

  render() {
    const { authData } = this.props;
    const { authState } = this.props;
    //console.log("AuthData APP:", authState, authData);

    if (authState !== "signedIn" || !authData) return null;

    return (
      <div className="App">
        <ViewProjects awsStorageConfig={AWS_CONFIG} />
      </div>
    );
  }
}
App.contextType = AppContext;

class MyAuth extends Component {
  constructor() {
    super();
    this.state = {};
  }

  handleAuthStateChange = async (authState, authData) => {
    //console.log("handleAuthStateChange", authState, authData);

    if (authState !== "signedIn" || !authData || !authData.username)
      return null;

    if (!authData.attributes) {
      let userAttributes = await Auth.userAttributes(authData);

      let mappedAttributes = Utils.valueArrayToObject(
        userAttributes,
        "Name",
        "Value"
      );

      /*    console.log(
           "handleAuthStateChange userAttributes",
           userAttributes,
           mappedAttributes
         ); */

      this.setState({ userAttributes: mappedAttributes });
    } else {
      //    console.log(" I have already attributes", authData.attributes);
    }
  };

  render() {
    return (
      <div>
        <Authenticator
          hideDefault={true}
          authState="signIn"
          theme={MyThemeTweak}
          onStateChange={this.handleAuthStateChange}
          amplifyConfig={AWS_CONFIG}
        >
          <TopPanel userAttributes={this.state.userAttributes} />
          <MySignIn override={SignIn} />
          <MySignUp override={SignUp} />
          <ConfirmSignIn />
          <ConfirmSignUp />
          <VerifyContact />

          <ForgotPassword />
          <RequireNewPassword />
          <App />
        </Authenticator>
      </div>
    );
  }
}
export default MyAuth;

//export default withAuthenticator(App, true);

class MySignUp extends SignUp {
  constructor(props) {
    super(props);
  }

  signUp() {
    const { username, password } = this.inputs;
    if (!Auth || typeof Auth.signUp !== "function") {
      throw new Error(
        "No Auth module found, please ensure @aws-amplify/auth is imported"
      );
    }

    let signup_info = {
      username,
      password,
      attributes: {
        email: username
      }
    };

    Auth.signUp(signup_info)
      .then(() => setTimeout(this.changeState("signedUp", username),3000))
      .catch(err => this.error(err));
  }

  showComponent(theme) {
    return (
      <FormSection theme={theme} autoComplete="off">
        <SectionHeader theme={theme}>
          {I18n.get("Create a new account")}
        </SectionHeader>
        <SectionBody theme={theme}>
          <FormField theme={theme}>
            <InputLabel>{I18n.get("Email Address")} *</InputLabel>
            <Input
               autoComplete="new-username"
              autoFocus
              placeholder={I18n.get("john.smith@gmail.com")}
              theme={theme}
              key="username"
              name="username"
              onChange={this.handleInputChange}
            />
          </FormField>
          <FormField theme={theme}>
            <InputLabel>{I18n.get("Password")} *</InputLabel>
            <Input
            autoComplete="new-password"
              placeholder={I18n.get("Create a password")}
              theme={theme}
              type="password"
              key="password"
              name="password"
              onChange={this.handleInputChange}
            />
          </FormField>
        </SectionBody>
        <SectionFooter theme={theme}>
          <SectionFooterPrimaryContent theme={theme}>
            <Button onClick={this.signUp} theme={theme}>
              {I18n.get("Create Account")}
            </Button>
          </SectionFooterPrimaryContent>
          <SectionFooterSecondaryContent theme={theme}>
            {I18n.get("Have an account? ")}
            <Link theme={theme} onClick={() => this.changeState("signIn")}>
              {I18n.get("Sign in")}
            </Link>
          </SectionFooterSecondaryContent>
        </SectionFooter>
      </FormSection>
    );
  }
}

class MySignIn extends SignIn {
  constructor(props) {
    super(props);
  }

  showComponent(theme) {
    const {
      authState,
      hide = [],
      federated,
      onStateChange,
      onAuthEvent,
      override = []
    } = this.props;

    const hideForgotPassword =
      !override.includes("ForgotPassword") &&
      hide.some(component => component === ForgotPassword);
    return (
      <FormSection theme={theme}>
        <SectionHeader theme={theme}>
          {I18n.get("Sign in to your account")}
        </SectionHeader>
        <SectionBody theme={theme}>
          <FormField theme={theme}>
            <InputLabel theme={theme}>{I18n.get("Username")} *</InputLabel>
            <Input
              autoFocus
              placeholder={I18n.get("Enter your username")}
              theme={theme}
              key="username"
              name="username"
              onChange={this.handleInputChange}
            />
          </FormField>
          <FormField theme={theme}>
            <InputLabel theme={theme}>{I18n.get("Password")} *</InputLabel>
            <Input
              placeholder={I18n.get("Enter your password")}
              theme={theme}
              key="password"
              type="password"
              name="password"
              onChange={this.handleInputChange}
            />
            {!hideForgotPassword && (
              <Hint theme={theme}>
                {I18n.get("Forget your password? ")}
                <Link
                  theme={theme}
                  onClick={() => this.changeState("forgotPassword")}
                >
                  {I18n.get("Reset password")}
                </Link>
              </Hint>
            )}
          </FormField>
        </SectionBody>
        <SectionFooter theme={theme}>
          <SectionFooterPrimaryContent theme={theme}>
            <Button
              theme={theme}
              onClick={this.signIn}
              disabled={this.state.loading}
            >
              {I18n.get("Sign In")}
            </Button>
          </SectionFooterPrimaryContent>
          {
            <SectionFooterSecondaryContent theme={theme}>
              {I18n.get("No account? ")}
              <Link theme={theme} onClick={() => this.changeState("signUp")}>
                {I18n.get("Create account")}
              </Link>
            </SectionFooterSecondaryContent>
          }
        </SectionFooter>
      </FormSection>
    );
  }
}
